export default __webpack_public_path__ + "static/media/image-4.5d91bc65.png";